package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Available colors for drawing on the whiteboard.
 */
@Serializable
enum class WhiteboardColor(val hexValue: Long) {
    @SerialName("black")
    BLACK(0xFF000000),

    @SerialName("red")
    RED(0xFFFF0000),

    @SerialName("blue")
    BLUE(0xFF0000FF),

    @SerialName("green")
    GREEN(0xFF00AA00),

    @SerialName("yellow")
    YELLOW(0xFFFFCC00),

    /** Whiteboard background color, used by the eraser rather than offered as a pen color. */
    @SerialName("white")
    WHITE(0xFFFFFFFF);

    companion object {
        /** Colors the GM can pick to draw with. */
        val palette: List<WhiteboardColor> = entries.filterNot { it == WHITE }
    }
}
